<template>
  <div class="nav-container">
    <div class="links-container">
      <router-link to="/" class="item" active-class="active">Home</router-link>
      <router-link to="/about" class="item" active-class="active"
        >About</router-link
      >
      <router-link to="/projects" class="item" active-class="active"
        >Featured Projects</router-link
      >
      <router-link to="/contact" class="item" active-class="active"
        >Contact</router-link
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "NavSection",
};
</script>

<style>
.nav-container {
  height: 5vh;
}

.links-container {
  height: 3rem;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 999;
  border-bottom: 1px solid #ffffff;
  background-image: url("../../images/abstract-2.jpg");
  background-size: cover;
  background-attachment: fixed;
}

.links-container > a {
  text-decoration: none;
  color: white;
  font-size: 20px;
  transition: 0.4s;
}

.active {
  border-bottom: 3px rgb(255, 255, 255) solid;
}

.active:hover,
.item:hover {
  background-color: #e95420;
}

@media only screen and (max-width: 500px) {
  .links-container {
    height: auto;
  }

  .links-container > a {
    font-size: 14px;
  }

  .item {
    padding: 5px 0;
  }

  .active {
    padding: 10px;
  }
}
</style>
